import React, { useEffect, useState } from "react";
import { Spin, Typography } from "antd";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../interceptor/axiosInstance";
import ApiRoutes from "../../routes/routeConstants/apiRoutes";

const { Title } = Typography;

/**
 * Loads release HTML from the API (`public/release_notes/<v>.html` on the server).
 */
export default function ReleaseNotes() {
  const location = useLocation();
  const q = new URLSearchParams(location.search);
  const version = q.get("v");
  const [html, setHtml] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axiosInstance
      .get<{ html: string | null }>(ApiRoutes.RELEASE_NOTES_CONTENT, {
        params: version ? { v: version } : {},
      })
      .then((res) => {
        if (!cancelled) setHtml(res.data.html ?? null);
      })
      .catch(() => {
        if (!cancelled) setHtml(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [version]);

  return (
    <div style={{ padding: "24px 32px", maxWidth: 840 }}>
      <Title level={3}>Release notes</Title>
      {version ? (
        <p style={{ color: "#595959", marginBottom: 16 }}>Version {version}</p>
      ) : null}
      <Spin spinning={loading}>
        {html ? (
          <div
            className="release-notes-html"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : !loading ? (
          <p style={{ color: "#8c8c8c" }}>
            No release notes file was found for this version. Ask your team to add
            HTML under <code>public/release_notes/</code> on the API server (e.g.{" "}
            <code>latest.html</code> or <code>{version || "1.0.0"}.html</code>).
          </p>
        ) : null}
      </Spin>
    </div>
  );
}
